import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Grid, Header, Segment } from 'semantic-ui-react';
import { ScrollableGrid } from '../styles/ScrollableGrid';
import cardColor from '../TasksListComponents/cardColor';
import Priority from '../TasksListComponents/Priority';
import TaskDescription from '../TasksListComponents/TaskDescription';
import UserDisplayedName from '../TasksListComponents/UserDisplayedName';
import Checkbox from '../TasksManagerList/Checkbox';
import { withRouter } from 'react-router-dom';

const TasksList = ({ tasks = [], checkboxesProps, grid, location }) => {
  if (tasks.length === 0) {
    return (
      <Segment basic>
        <Header as="h3" textAlign="center">
          No results
        </Header>
      </Segment>
    );
  }
  return (
    <div style={ScrollableGrid}>
      <Grid padded style={{ minWidth: grid.minWidth }}>
        <Grid.Row
          className={checkboxesProps ? 'paddedCheckbox' : ''}
          verticalAlign="middle"
          style={{ minWidth: grid.minWidth }}
        >
          {checkboxesProps && (
            <Grid.Column width={grid.selectWidth}>
              <Checkbox
                handleClick={checkboxesProps.handleSelectAll}
                checked={checkboxesProps.areAllChecked}
              />
            </Grid.Column>
          )}
          <Grid.Column width={grid.priorityWidth}>
            <Card.Meta>Priority</Card.Meta>
          </Grid.Column>
          <Grid.Column width={grid.descriptionWidth}>
            <Card.Meta>Description</Card.Meta>
          </Grid.Column>
          <Grid.Column width={grid.assigneeWidth}>
            <Card.Meta>Assignee</Card.Meta>
          </Grid.Column>
          <Grid.Column width={grid.idWidth}>
            <Card.Meta>ClaimID</Card.Meta>
          </Grid.Column>
          <Grid.Column width={grid.statusWidth}>
            <Card.Meta>Claim Status</Card.Meta>
          </Grid.Column>
          <Grid.Column width={grid.dateWidth} style={{ textAlign: 'right' }}>
            <Card.Meta>Created</Card.Meta>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {tasks.map(task => (
        <Link
          key={task.id}
          to={{
            pathname: `/task/${task.id}`,
            state: { previousPath: location.pathname.substring(1) }
          }}
        >
          <Card fluid style={{ ...cardColor(task), minWidth: grid.minWidth }}>
            <Card.Content>
              <Grid style={{ minWidth: grid.minWidth }}>
                <Grid.Row
                  className={checkboxesProps ? 'paddedCheckbox' : ''}
                  verticalAlign="middle"
                  style={{ minWidth: grid.minWidth }}
                >
                  {checkboxesProps && (
                    <Grid.Column width={grid.selectWidth}>
                      <Checkbox
                        handleClick={e =>
                          checkboxesProps.handleCheckboxClick(e, task.id)
                        }
                        checked={checkboxesProps.checkboxes[task.id]}
                      />
                    </Grid.Column>
                  )}
                  <Grid.Column width={grid.priorityWidth}>
                    <Card.Header>
                      <Priority priority={task.priority} />
                    </Card.Header>
                  </Grid.Column>
                  <Grid.Column width={grid.descriptionWidth}>
                    <Card.Meta>
                      <TaskDescription task={task} />
                    </Card.Meta>
                  </Grid.Column>
                  <Grid.Column width={grid.assigneeWidth}>
                    <Card.Meta>
                      <UserDisplayedName user={task.user} />
                    </Card.Meta>
                  </Grid.Column>
                  <Grid.Column width={grid.idWidth}>
                    <Card.Meta>{task.claimId}</Card.Meta>
                  </Grid.Column>
                  <Grid.Column
                    width={grid.statusWidth}
                    style={{ textAlign: 'right' }}
                  >
                    <Card.Meta
                      style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
                    >
                      {task.claim ? task.claim.crmState : '-'}
                    </Card.Meta>
                  </Grid.Column>
                  <Grid.Column
                    width={grid.dateWidth}
                    style={{ textAlign: 'right' }}
                  >
                    <Card.Meta>
                      {moment(task.createdAt).format('DD/MM/YYYY')}
                    </Card.Meta>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Card.Content>
          </Card>
        </Link>
      ))}
    </div>
  );
};

export default withRouter(TasksList);



// WEBPACK FOOTER //
// ./src/component/TasksListComponents/List.js